import { Navigate, useLocation } from 'react-router-dom';
import { useConvexAuth } from 'convex/react';

type Props = {
  children: React.ReactNode;
};

export function ProtectedRoute({ children }: Props) {
  const { isLoading, isAuthenticated } = useConvexAuth();
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const error = search.get('error');
  const errorDescription = search.get('error_description');

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-pulse text-muted-foreground">Loading…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    const signInTo = error
      ? `/signin?error=${encodeURIComponent(error)}${errorDescription ? `&error_description=${encodeURIComponent(errorDescription)}` : ''}`
      : '/signin';
    return <Navigate to={signInTo} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
